// SiteUp: o painel da conversa mostra um card por vez (setas entre os funis
// do lead no KanbanActions). Status, apagar e "Atualizar com IA" agem no card
// que está na tela, não sempre no primeiro de `kanban_items`.

export const resolvePanelKanbanItem = (chatItems, visibleItem) => {
  if (visibleItem?.id) return visibleItem;
  return (Array.isArray(chatItems) && chatItems[0]) || null;
};

// Junta o card atualizado na lista da conversa pelo id. O card de outro funil
// pode não estar em `kanban_items` (a API da conversa traz só o mais recente):
// nesse caso entra no fim, sem trocar o primeiro.
export const mergePanelKanbanItem = (chatItems, updatedItem) => {
  const items = Array.isArray(chatItems) ? chatItems : [];
  if (!updatedItem?.id) return items;
  const exists = items.some(item => item.id === updatedItem.id);
  if (!exists) return [...items, updatedItem];
  return items.map(item =>
    item.id === updatedItem.id ? { ...item, ...updatedItem } : item
  );
};
